const module = { name: 'Fandango/cookie', exports: {} }; const exports = module.exports;



const RegEx = {
    KEY_VALUES: /^(.*?)=(.*)$/
}


const DEFAULT_OPTIONS = Object.freeze({
    expires: 365 * 24 * 3600,
    domain: '.fandango.com',
    path: '/',
    secure: window.location.protocol === 'https:',
    nulltoremove: true,
    autojson: false,
    autoencode: false,
    encode: encodeURIComponent,
    decode: decodeURIComponent
})


const GlobalOptions = Object.assign({}, DEFAULT_OPTIONS)
function applyDefaults(newValues, defaultValues) {
    const obj = Object.assign({}, newValues);
    Object.keys(defaultValues)
        .filter(key => obj[key] === undefined)
        .forEach(key => obj[key] = defaultValues[key]);
    return obj;
}
function expires(time) {
    let expiry = time;
    if (!(expiry instanceof Date)) {
        expiry = new Date();
        expiry.setTime(expiry.getTime() + (time * 1000));
    }
    return expiry.toUTCString();
}
function splitKeyValuePair(value) {
    const matches = value.match(RegEx.KEY_VALUES);
    if (!matches) {
        return [];
    }
    return [matches[1], matches[2]];
}
function parseCookies(opt) {
    return document.cookie.split(/;\s*/)
        .map(opt.autoencode ? opt.decode : d => d)
        .map(splitKeyValuePair)
        .reduce((parts, [key, value]) => {
        parts[key] = value;
        return parts;
    }, {});
}
function get(cookieName, options) {
    const opt = applyDefaults(options, GlobalOptions);
    const cookies = parseCookies(opt);
    const value = cookies[cookieName];
    if (!opt.autojson) {
        return value;
    }
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return value;
    }
}
function setCookie(name, value, options) {
    const opt = applyDefaults(options, GlobalOptions);
    const expired = value === undefined || (opt.nulltoremove && value === null);
    const str = opt.autojson ? JSON.stringify(value) : value;
    let encoded = opt.autoencode ? opt.encode(str) : str;
    if (expired) {
        encoded = '';
    }
    let cookie = `${opt.encode(name)}=${encoded}`;
    cookie += opt.expires ? (';expires=' + expires(expired ? -10000 : opt.expires)) : '';
    cookie += ';path=' + opt.path;
    cookie += opt.domain ? (';domain=' + opt.domain) : '';
    cookie += opt.secure ? ';secure' : '';
    if (opt.test) {
        opt.test(cookie);
    }
    document.cookie = cookie;
}
function set(nameOrCookies, value, options) {
    if (!arguments.length || !nameOrCookies) {
        return null;
    }
    if (typeof nameOrCookies === 'string') {
        return setCookie(nameOrCookies, value, options || {});
    }
    if (typeof nameOrCookies !== 'object') {
        return null;
    }
    const opt = applyDefaults(value, GlobalOptions);
    const cookies = nameOrCookies;
    for (const key in cookies) {
        setCookie(key, cookies[key], opt);
    }
}
function deleteCookie(name, options) {
    const opt = options || {};
    opt.nulltoremove = true;
    setCookie(name, null, opt);
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
function init(opts) {
    Object.assign(GlobalOptions, opts);
}
module.exports = {
    init,
    get,
    set,
    delete: deleteCookie,
    deleteCookie
};
extendLegacy('cookie', module.exports);
export default module.exports;